import { Injectable, inject } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

declare let gtag: Function;

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private deviceService = inject(DeviceDetectorService);

  public trackEvent(event: string, params: Record<string, any>) {
    if (typeof gtag !== 'undefined') {
      const localTime = new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
      const eventParams = {
        ...params,
        event_timestamp: localTime 
      };
      gtag('event', event, eventParams);
      console.log(`[Analytics] ${event} logged:`, eventParams);
    }
  }

  logAppContext() {
    const deviceInfo = this.deviceService.getDeviceInfo();
    this.trackEvent('app_context', {
      device_model: deviceInfo.device || 'Desktop',
      device_os: deviceInfo.os,
      browser: deviceInfo.browser,
      app_version: '1.0.0', 
      is_mobile: this.deviceService.isMobile(),
    });
  }

  logSystemError(category: string, message: string, orderId?: string | number) {
    const deviceInfo = this.deviceService.getDeviceInfo();
    this.trackEvent('system_error', {
      error_category: category,
      error_message: message,
      order_id: orderId ? orderId.toString() : null,
      device_specs: `${deviceInfo.browser} ${deviceInfo.browser_version} on ${deviceInfo.os}`
    });
  }

  logPurchase(orderId: string | number, serviceType: string) {
    this.trackEvent('purchase', {
      order_id: orderId.toString(),
      currency: 'INR',
      service_type: serviceType
    });
  }

  logVerificationStep(stepName: string, orderId?: string | number) {
    this.trackEvent('verification_step', {
      step_name: stepName,
      order_id: orderId ? orderId.toString() : null
    });
  }

  logCameraDebug(status: 'success' | 'error', label: string, errorName?: string, resolution?: string) {
    const deviceInfo = this.deviceService.getDeviceInfo();
    this.trackEvent('camera_debug', {
      status,
      label,
      error_name: errorName,
      resolution,
      browser_info: `${deviceInfo.browser} ${deviceInfo.browser_version} on ${deviceInfo.os}`
    });
  }

  /**
   * Compares adoption of "click anywhere on the row" vs the eye-icon click
   * for triggering a grid's View action. No order/record id is sent —
   * only which tab and which entry point was used.
   */
  trackViewInteraction(tab: string, source: 'row_click' | 'icon_click') {
    this.trackEvent('view_order_interaction', {
      tab,
      interaction_type: source,
    });
  }

  logApiFailure(endpoint: string, method: string, statusCode: number, errorMessage: string, orderId?: string | null, orgId?: string | null) {
      this.trackEvent('api_failure', {
        endpoint: endpoint,
        method: method,
        status_code: statusCode,
        error_message: errorMessage,
        order_id: orderId ? orderId.toString() : null,
        org_id: orgId ? orgId.toString() : null 
      });
    }
    
}